/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Experiment
 */
export interface Experiment {
  /**
   *
   * @type {string}
   * @memberof Experiment
   */
  experimentId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Experiment
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Experiment
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Experiment
   */
  purpose?: string;
  /**
   *
   * @type {string}
   * @memberof Experiment
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof Experiment
   */
  metadata?: string;
  /**
   *
   * @type {string}
   * @memberof Experiment
   */
  companyId?: string;
}

/**
 * Check if a given object implements the Experiment interface.
 */
export function instanceOfExperiment(value: object): value is Experiment {
  return true;
}

export function ExperimentFromJSON(json: any): Experiment {
  return ExperimentFromJSONTyped(json, false);
}

export function ExperimentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Experiment {
  if (json == null) {
    return json;
  }
  return {
    experimentId:
      json["experimentId"] == null ? undefined : json["experimentId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    name: json["name"] == null ? undefined : json["name"],
    purpose: json["purpose"] == null ? undefined : json["purpose"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
  };
}

export function ExperimentToJSON(json: any): Experiment {
  return ExperimentToJSONTyped(json, false);
}

export function ExperimentToJSONTyped(
  value?: Experiment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experimentId: value["experimentId"],
    createdAt: value["createdAt"],
    name: value["name"],
    purpose: value["purpose"],
    createdBy: value["createdBy"],
    metadata: value["metadata"],
    companyId: value["companyId"],
  };
}
